<template>
  <template v-if="!isPdf">
    <h2 class="titleStepForm">Membership Type</h2>
    <p class="ea-sub-note">
      The membership type and residency the applicant selected. These are
      read-only.
    </p>

    <div class="ea-residency at-residency">
      <span class="ea-residency__label">Residency</span>
      <div class="residency-toggle" role="group" aria-label="Residency">
        <button
          type="button"
          class="residency-opt"
          :class="{ active: residencyType === 'local' }"
          disabled
        >
          Local
        </button>
        <button
          type="button"
          class="residency-opt"
          :class="{ active: residencyType === 'foreigner' }"
          disabled
        >
          Foreigner
        </button>
      </div>
    </div>

    <div class="ea-types at-types">
      <label
        for="adultRadio"
        class="ea-type is-readonly"
        :class="{ 'is-selected': radioSelected1 === 'adult' }"
      >
        <input
          type="radio"
          v-model="radioSelected1"
          value="adult"
          name="radioAdult"
          class="ea-type__input"
          id="adultRadio"
          disabled
        />
        <span class="ea-type__radio" aria-hidden="true"></span>
        <span class="ea-type__icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" /><path d="M4.5 21v-1a6 6 0 0 1 6-6h3a6 6 0 0 1 6 6v1" /></svg>
        </span>
        <span class="ea-type__text">
          <strong>Adult</strong>
          <span>
            Any person 18 years and over at the time of application is
            considered an adult.
          </span>
        </span>
      </label>
      <label
        for="minorRadio"
        class="ea-type is-readonly"
        :class="{ 'is-selected': radioSelected1 === 'minor' }"
      >
        <input
          type="radio"
          v-model="radioSelected1"
          value="minor"
          name="radioAdult"
          class="ea-type__input"
          id="minorRadio"
          disabled
        />
        <span class="ea-type__radio" aria-hidden="true"></span>
        <span class="ea-type__icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" /><path d="M2.5 20v-.5A5.5 5.5 0 0 1 8 14h2a5.5 5.5 0 0 1 5.5 5.5v.5" /><path d="M16.5 11a2.7 2.7 0 1 0 0-5.3" /><path d="M18.5 14.3a4.5 4.5 0 0 1 3 4.2V20" /></svg>
        </span>
        <span class="ea-type__text">
          <strong>Minor</strong>
          <span>
            Any person under the age of 18 at the time of application is
            considered a minor.
          </span>
        </span>
      </label>
    </div>
  </template>

  <template v-else>
  <div class="d-flex justify-content-end align-items-center mb-2">
    <span class="font-size-14 me-2">
      Residency
    </span>
    <div class="residency-toggle" role="group" aria-label="Residency">
      <button
        type="button"
        class="residency-opt"
        :class="{ active: residencyType === 'local' }"
        disabled
      >
        Local
      </button>
      <button
        type="button"
        class="residency-opt"
        :class="{ active: residencyType === 'foreigner' }"
        disabled
      >
        Foreigner
      </button>
    </div>
  </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="bg-theme p-3">
            <div class="row">
              <div class="col-md-6">
                <label
                  for="adultRadio"
                  class="mb-0 p-relative border w-100 labelStyleRadioCstm"
                >
                  <input
                    type="radio"
                    v-model="radioSelected1"
                    value="adult"
                    name="radioAdult"
                    class="inputRadioCstm d-none"
                    id="adultRadio"
                    disabled
                  />
                  <span class="radioCircleIcon">
                    <i
                      class="mdi mdi-circle-outline text-white font-size-20"
                    ></i>
                    <i
                      class="mdi mdi-checkbox-marked-circle text-white theme-check font-size-20"
                    ></i>
                  </span>
                  <h4 class="font-size-14 text-white mb-0 ms-2">
                    Adult (Any person 18 years and over at the
                    time of application is considered an adult)
                  </h4>
                </label>
              </div>
              <div class="col-md-6">
                <label
                  for="minorRadio"
                  class="mb-0 p-relative border w-100 labelStyleRadioCstm"
                >
                  <input
                    type="radio"
                    v-model="radioSelected1"
                    value="minor"
                    name="radioAdult"
                    class="inputRadioCstm d-none"
                    id="minorRadio"
                    disabled
                  />
                  <span class="radioCircleIcon">
                    <i
                      class="mdi mdi-circle-outline text-white font-size-20"
                    ></i>
                    <i
                      class="mdi mdi-checkbox-marked-circle text-white theme-check font-size-20"
                    ></i>
                  </span>
                  <h4 class="font-size-14 text-white mb-0 ms-2">
                    Minor (Any person under the age of 18 at the
                    time of application is considered a minor)
                  </h4>
                </label>
              </div>
            </div>
          </div>
        </div>
        <template v-if="!isPdf">
        <!-- Optional field: PEP -->
        </template>
      </div>
  </template>
</template>


<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewApplicantType",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["residencyType", "radioSelected1"],
    }),
  ],
};
</script>

<style scoped>
.at-residency {
  justify-content: flex-end;
  margin: 4px 0 18px;
}
.at-types {
  margin-bottom: 8px;
}
.ea-type.is-readonly {
  cursor: default;
}
</style>